@if (documentHistory) {
    <mat-accordion class="history px-1" data-uiid="documentmanagerhistory">
        @for (historyEntry of documentHistory; track historyEntry) {
            <mat-expansion-panel
                #matExpensionPanel
                [attr.data-uiid]="
                    'documentmanagerhistory-row-' + historyEntry.Guid + '-' + historyEntry.Version
                "
            >
                <mat-expansion-panel-header
                    [attr.data-uiid]="
                        'documentmanagerhistory-expand-' +
                        historyEntry.Guid +
                        '-' +
                        historyEntry.Version
                    "
                >
                    <mat-panel-title>
                        <span
                            [attr.data-uiid]="
                                'documentmanagerhistory-version-' +
                                historyEntry.Guid +
                                '-' +
                                historyEntry.Version
                            "
                            class="ms-2 text-nowrap"
                            >Version: {{ historyEntry.Version }}</span
                        >
                        <i
                            [attr.data-uiid]="
                                'documentmanagerhistory-name-' +
                                historyEntry.Guid +
                                '-' +
                                historyEntry.Version
                            "
                            class="p-2 text-truncate"
                            >{{ historyEntry.Name }}</i
                        >
                    </mat-panel-title>
                    <mat-panel-description>
                        <a
                            [attr.data-uiid]="
                                'documentmanagerhistory-download-' +
                                historyEntry.Guid +
                                '-' +
                                historyEntry.Version
                            "
                            class="fas fa-download"
                            href="api/documents/{{ historyEntry.Guid }}/data/{{
                                historyEntry.Version
                            }}"
                            HrefTarget="_blank"
                        ></a>
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <table class="table">
                    <tbody>
                        <tr>
                            <th>User</th>
                            <td
                                [attr.data-uiid]="
                                    'documentmanagerhistory-user-' +
                                    historyEntry.Guid +
                                    '-' +
                                    historyEntry.Version
                                "
                            >
                                {{ historyEntry.Username }}
                            </td>
                        </tr>
                        <tr>
                            <th>Date</th>
                            <td
                                [attr.data-uiid]="
                                    'documentmanagerhistory-date-' +
                                    historyEntry.Guid +
                                    '-' +
                                    historyEntry.Version
                                "
                            >
                                {{ historyEntry.Date | dateTimeFormat }}
                            </td>
                        </tr>
                        <tr>
                            <th>Type</th>
                            <td
                                [attr.data-uiid]="
                                    'documentmanagerhistory-type-' +
                                    historyEntry.Guid +
                                    '-' +
                                    historyEntry.Version
                                "
                            >
                                {{ historyEntry.DocumentType }}
                            </td>
                        </tr>
                        <tr>
                            <th>Description</th>
                            <td
                                [attr.data-uiid]="
                                    'documentmanagerhistory-description-' +
                                    historyEntry.Guid +
                                    '-' +
                                    historyEntry.Version
                                "
                                tooltip="{{ historyEntry.Description }}"
                            >
                                {{ historyEntry.Description }}
                            </td>
                        </tr>
                        <tr>
                            <th>File size</th>
                            <td
                                [attr.data-uiid]="
                                    'documentmanagerhistory-filesize-' +
                                    historyEntry.Guid +
                                    '-' +
                                    historyEntry.Version
                                "
                            >
                                {{ historyEntry.DataSize | fileSize }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </mat-expansion-panel>
        }
    </mat-accordion>
}
